import { useEffect, useMemo, useState } from 'react';
import Modal from '../../../../../commons/Modal/Modal';
import { CreateConsultPaymentModalProps } from './CreateConsultPaymentModal.types';
import moment from 'moment';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { UserENT } from '../../../../../../types/models/user/user.types';
import { createPortal } from 'react-dom';
import { useIsDev } from '../../../../../../hooks/useIsDev/useIsDev';
import { useSignatureConsultPUB } from '../../../../../../hooks/fetchers/useSignatureConsultPUB/useSignatureConsultPUB';
import '../../../../../../styles/Register.css';
import { amountWithTVA } from '../../../../../../utils/helpers/price/amountWithTVA';

export default ({
  paymentData: { consultationId, amount },
  ...props
}: CreateConsultPaymentModalProps) => {
  const { id, email, phone, firstName, lastName } = useCurrentUser() as any as UserENT;

  const IS_DEV = useIsDev();

  const currentTime = useMemo(() => moment().utc().format('YYYYMMDDHHmmss'), []);

  const { data, refetch, isLoading } = useSignatureConsultPUB(
    { consultationId, currentTime },
    {
      enabled: props.isOpen,
    }
  );

  const [isTriggered, setTriggered] = useState(false);

  const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);
  const [isChecked, setChecked] = useState(false);

  const mountNode = useMemo(() => contentRef?.contentWindow?.document?.body, [contentRef]);

  useEffect(() => {
    if (props.isOpen) {
      refetch();
    }
  }, [props.isOpen]);

  // const getSuccessPaymentSignature = (id: number, transId: number) => {}

  if (isLoading || !data) return <p>Chargement...</p>;

  return (
    <Modal {...props}>
      {!isTriggered && (
        <div className="register__payment-price">
          <div className="register__payment-price-row">
            <span>Premium</span>
            <span>{amount?.toFixed(2)}€</span>
          </div>
          <div className="register__payment-price-row">
            <span>TVA 20%</span>
            <span>{(amountWithTVA(amount || 0) - (amount || 0)).toFixed(2)}€</span>
          </div>
          <div className="register__payment-price-row register__payment-price-row--total">
            <span>Total TTC</span>
            <span>{amountWithTVA(amount || 0).toFixed(2)}€</span>
          </div>
        </div>
      )}
      <iframe
        id="nameFrame"
        name="nameFrame"
        className="register_payment-iframe"
        width={'100%'}
        height={540}
        ref={setContentRef}>
        {mountNode &&
          createPortal(
            <form
              method="POST"
              action="https://sogecommerce.societegenerale.eu/vads-payment/"
              target="nameFrame">
              <input type="hidden" name="vads_action_mode" value="IFRAME" />
              <input type="hidden" name="vads_amount" value={amountWithTVA(amount) * 100} />
              <input type="hidden" name="vads_ctx_mode" value={IS_DEV ? 'TEST' : 'PRODUCTION'} />
              <input type="hidden" name="vads_currency" value="978" />
              <input type="hidden" name="vads_cust_cell_phone" value={phone} />
              <input type="hidden" name="vads_cust_email" value={email} />
              <input type="hidden" name="vads_cust_first_name" value={firstName} />
              <input type="hidden" name="vads_cust_id" value={`PUB${id}`} />
              <input type="hidden" name="vads_cust_last_name" value={lastName} />
              <input type="hidden" name="vads_language" value="fr" />
              <input type="hidden" name="vads_page_action" value="PAYMENT" />
              <input type="hidden" name="vads_payment_config" value="SINGLE" />
              <input type="hidden" name="vads_site_id" value="51177819" />
              <input type="hidden" name="vads_trans_date" value={currentTime} />
              <input type="hidden" name="vads_trans_id" value={data?.transId} />
              <input type="hidden" name="vads_order_id" value={consultationId} />
              <input type="hidden" name="vads_redirect_error_timeout" value="2" />
              <input type="hidden" name="vads_redirect_success_timeout" value="2" />
              <input
                type="hidden"
                name="vads_url_success"
                value={
                  IS_DEV
                    ? 'http://localhost:5000/payment/PUB/consult/success'
                    : 'https://www.publiconsult.fr/payment/PUB/consult/success'
                }
              />
              <input
                type="hidden"
                name="vads_url_refused"
                value={
                  IS_DEV
                    ? 'http://localhost:3000/step_wizard/ENT'
                    : 'https://www.publiconsult.fr/step_wizard/ENT'
                }
              />
              <input
                type="hidden"
                name="vads_url_error"
                value={
                  IS_DEV
                    ? 'http://localhost:3000/step_wizard/ENT'
                    : 'https://www.publiconsult.fr/step_wizard/ENT'
                }
              />
              {/* <input type="hidden" name="vads_url_return" value="https://sogecommerce.societegenerale.eu/demo/fr/iframe/" /> */}
              <input type="hidden" name="vads_return_mode" value="POST" />
              <input type="hidden" name="vads_version" value="V2" />
              <input
                type="hidden"
                name="vads_theme_config"
                value="FORM_TARGET=_top;3DS_LOGOS=false"
              />
              <input type="hidden" name="signature" value={data?.signature} />
              <div
                style={{
                  overflowY: 'scroll',
                  overflowX: 'hidden',
                  height: isTriggered ? 350 : 0,
                  marginBottom: 16,
                }}>
                <p style={{ fontFamily: 'sans-serif', fontSize: 13 }}></p>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  columnGap: 8,
                }}>
                <input type="checkbox" onChange={(e) => setChecked(e.target.checked)} />
                <span style={{ fontFamily: 'sans-serif', fontSize: 13 }}>
                  Je reconnais avoir pris connaissance et j’accepte les{' '}
                  <a rel="noreferrer" target="_blank" href="https://www.publiconsult.fr/CGV">
                    conditions générales de vente
                  </a>
                  .
                </span>
              </div>
              <button
                type="submit"
                style={{
                  width: '100%',
                  border: 'none',
                  padding: 16,
                  margin: '16px 0',
                  borderRadius: 14,
                  fontSize: 18,
                  color: 'white',
                  textTransform: 'uppercase',
                  backgroundImage: isChecked
                    ? 'linear-gradient(to right, #DE5835, #BC2F2A)'
                    : 'var(--gray-1)',
                  cursor: 'pointer',
                }}
                disabled={!isChecked}
                onClick={() => setTriggered(true)}>
                Paiement par carte bancaire
              </button>
            </form>,
            mountNode
          )}
      </iframe>
    </Modal>
  );
};
